import axios from "axios";

// Dev fallback: user-level Windows env often points at :8000 while the current API runs on :8002.
const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL === "http://127.0.0.1:8000"
    ? "http://127.0.0.1:8002"
    : process.env.REACT_APP_BACKEND_URL || "http://127.0.0.1:8002";
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

const isProd = process.env.NODE_ENV === "production";
if (isProd) {
    localStorage.removeItem("loomara_token");
}

// Local HTTP dev may return a bearer token (production uses HttpOnly cookie only).
api.interceptors.request.use((config) => {
    if (!isProd) {
        const token = localStorage.getItem("loomara_token");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
    }
    return config;
});

export default api;

export function formatApiError(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export function inr(n) {
    if (n == null) return "";
    return "₹" + Number(n).toLocaleString("en-IN");
}
